import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface StatTileProps {
  label: string;
  /** Already formatted (`formatNumber`, `formatUsd`…). */
  value: string;
  /** A line under the figure, e.g. "12.5% of answers" or a period. */
  hint?: ReactNode;
  className?: string;
}

/** One headline figure: a label, the value, and an optional hint. Plain text throughout. */
export function StatTile({ label, value, hint, className }: StatTileProps) {
  return (
    <div
      className={cn(
        "flex min-w-0 flex-col gap-1 rounded-lg border border-line bg-surface-raised p-4",
        className,
      )}
    >
      <dt className="text-sm text-chart-label">{label}</dt>
      <dd className="text-2xl font-semibold tabular-nums text-fg">{value}</dd>
      {hint ? <dd className="text-xs text-fg-muted">{hint}</dd> : null}
    </div>
  );
}

/** A row of stat tiles as one description list. */
export function StatGrid({ children, className }: { children: ReactNode; className?: string }) {
  return (
    <dl
      className={cn(
        "grid grid-cols-2 gap-3 sm:grid-cols-[repeat(auto-fit,minmax(10rem,1fr))]",
        className,
      )}
    >
      {children}
    </dl>
  );
}
